import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Homepage from './pages/Homepage';
import RequestDataset from './pages/RequestDataset';
import ForBusinesses from './pages/ForBusinesses';
import ForUsers from './pages/ForUsers';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import DeleteAccount from './pages/DeleteAccount';
import AndroidTesters from './pages/AndroidTesters';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/request-dataset" element={<RequestDataset />} />
        <Route path="/for-businesses" element={<ForBusinesses />} />
        <Route path="/for-users" element={<ForUsers />} />
        <Route path="/for-contributors" element={<ForUsers />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
        <Route path="/android-testers" element={<AndroidTesters />} />
      </Routes>
    </Router>
  );
}

export default App;


